import DiscoverBrandSearch from './DiscoverBrandSearch';

export default DiscoverBrandSearch;
